import type { Account } from "./models.js";

export const accountCreatorUid = (users: Account["users"]) =>
  Object.entries(users ?? {}).sort(
    ([, a], [, b]) => a.addedAt.toMillis() - b.addedAt.toMillis(),
  )[0]?.[0];
